import { createBoundedCache } from './bounded-cache';
const BATCH_WINDOW_MS = 150;
const MAX_CACHE_SIZE = 150;
const normalizeEmail = (email)=>email.trim().toLowerCase();
const fetchEmailValidity = async (emailAddresses, validateEmails)=>{
    const validityByEmail = new Map();
    try {
        const results = await validateEmails({
            emailAddresses
        });
        results.forEach((result)=>{
            validityByEmail.set(normalizeEmail(result.emailAddress), result.valid);
        });
        return {
            validityByEmail,
            requestSucceeded: true
        };
    } catch  {
        return {
            validityByEmail,
            requestSucceeded: false
        };
    }
};
const resolveBatch = (batch, { validityByEmail, requestSucceeded }, cache)=>{
    for (const [email, resolvers] of batch){
        const isValid = validityByEmail.get(email) ?? true;
        if (requestSucceeded && validityByEmail.has(email)) {
            cache.set(email, isValid);
        }
        for (const resolve of resolvers){
            resolve(isValid);
        }
    }
};
export function createEmailDeliverabilityValidator(validateEmails) {
    const cache = createBoundedCache(MAX_CACHE_SIZE);
    let queue = new Map();
    let batchTimer;
    const flush = async ()=>{
        batchTimer = undefined;
        const batch = queue;
        queue = new Map();
        if (batch.size === 0) {
            return;
        }
        const outcome = await fetchEmailValidity(Array.from(batch.keys()), validateEmails);
        resolveBatch(batch, outcome, cache);
    };
    const scheduleFlush = ()=>{
        if (!batchTimer) {
            batchTimer = setTimeout(()=>{
                void flush();
            }, BATCH_WINDOW_MS);
        }
    };
    const validate = (email)=>{
        const normalizedEmail = normalizeEmail(email);
        const cached = cache.get(normalizedEmail);
        if (cached !== undefined) {
            return Promise.resolve(cached);
        }
        return new Promise((resolve)=>{
            const resolvers = queue.get(normalizedEmail) ?? [];
            resolvers.push(resolve);
            queue.set(normalizedEmail, resolvers);
            scheduleFlush();
        });
    };
    return {
        validate
    };
}

//# sourceMappingURL=email-availability-validation-service.js.map